export const societesBasePath = 'societes';
export const listeSocietesPath = '';
export const listeSocietesFullPath = `${societesBasePath}/${listeSocietesPath}`;
